/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Metrics_Chart_TitleInputs */

const en_ui_metrics_chart_title = /** @type {(inputs: Ui_Metrics_Chart_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Performance Metrics`)
};

const de_ui_metrics_chart_title = /** @type {(inputs: Ui_Metrics_Chart_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leistungsmetriken`)
};

/**
* | output |
* | --- |
* | "Performance Metrics" |
*
* @param {Ui_Metrics_Chart_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_metrics_chart_title = /** @type {((inputs?: Ui_Metrics_Chart_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Metrics_Chart_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_metrics_chart_title(inputs)
	return de_ui_metrics_chart_title(inputs)
});